export default __webpack_public_path__ + "static/media/opensans-light-webfont.7e7471e7.woff";